import { getPublicApiUrl, AXIOS_UNAUTHED } from './shared';

const login = (username, password) => {
  return AXIOS_UNAUTHED.post(`${getPublicApiUrl()}/login`, {
    username,
    password
  });
};

export { login };
